module.exports = __webpack_public_path__ + "static/media/noa-logo.2ce5de54.png";